/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from "react";
import { useParams, NavLink } from "react-router-dom";
import Swal from "sweetalert2";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Pagination from "@mui/material/Pagination";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Avatar from "@mui/material/Avatar";
import InputAdornment from "@mui/material/InputAdornment";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDInput from "components/MDInput";
import MDCheckbox from "components/MDCheckbox";
import MDSelect from "components/MDSelect";
import TableHeader from "components/Table/TableHeader";
import TabPanel from "components/TabPanel/TabPanel";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Navbar from "examples/Navbars/NavBar";
import Footer from "examples/Footer";
import { useTranslation } from "react-i18next";
import { APP_STATE } from "services/Define";
import { FetchData } from "services/Request";
import { useSelector } from "react-redux";
import * as Func from "services/Function";
import nopic from "assets/images/nopic.jpg";
import UserUpload from "./UserUpload";

const initAttr = {
  id: "",
  code: "",
  role_id: "",
  image_id: "",
  branch_id: "",
  name: "",
  surname: "",
  tel: "",
  email: "",
  user_name: "",
  idcard: "",
  user_pass: "",
  user_pass_again: "",
  address: "",
  province_id: "",
  district_id: "",
  subdistrict_id: "",
  zipcode: "",
  image: nopic,
  enable: "Y",
  created_at: "",
  updated_at: "",
};

const initFind = {
  search: "",
  order_by: "tb.id",
  order_sort: "desc",
  page: 1,
  perPage: 10,
  pageTotal: 0,
};

function User() {
  const mod = "user";
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [pageTotal, setPageTotal] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [record, setRecord] = useState([]);
  const [show, setShow] = useState(null);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [confirmRegister, setConfirmRegister] = useState(false);
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState(initFind.order_sort);
  const [orderBy, setOrderBy] = useState(initFind.order_by);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalDel, setModalDel] = useState(false);
  const [cboProvince, setCboProvince] = useState([]);
  const [cboDistrict, setCboDistrict] = useState([]);
  const [cboSubDistrict, setCboSubDistrict] = useState([]);
  const [cboRole, setCboRole] = useState([]);
  const [cboBranch, setCboBranch] = useState([]);
  const [tab, setTab] = useState(0);

  const openShow = (e) => setShow(e.currentTarget);
  const closeShow = () => setShow(null);

  const initHeader = [
    { id: "tb.image_id", label: t(`attr.image`), align: "center" },
    { id: "tb.id", label: t(`attr.id`), align: "center" },
    { id: "tb.code", label: t(`attr.code`), align: "center" },
    { id: "tb.name", label: t(`attr.firstname`), align: "left" },
    { id: "tb.surname", label: t(`attr.lastname`), align: "left" },
    { id: "tb.role_id", label: "สิทธิ์การใช้", align: "left" },
    { id: "tb.branch_id", label: "สาขา", align: "left" },
    { id: "tb.username", label: t(`authen.username`), align: "center" },
    { id: "tb.enable", label: t(`attr.enable`), align: "center" },
    { id: "tb.created_at", label: t(`attr.created_at`), align: "center" },
  ];

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon="notifications"
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);
    setRecord([]);
    closeShow();

    FetchData("POST", `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      page: data.page,
      per_page: data.perPage,
      orderby: data.order_by,
      ordersort: data.order_sort,
      role_id: data.role_id,
    }).then((result) => {
      if (result.status === "ok") {
        setRecord(result.data);

        setPageTotal(result.total_pages);
        setPageNo(result.page);
      }
      setLoading(false);
    });
  };

  const district = (province_id) => {
    setCboDistrict([]);
    setCboSubDistrict([]);
    FetchData("OPTIONS", `/${mod}/district`, app.token, {
      lang: app.lang,
      province_id: province_id,
    }).then((result) => {
      if (result.status === "ok") {
        setCboDistrict(result.district);
      } else {
        Func.exitApp();
      }
    });
  };

  const subDistrict = (district_id) => {
    setCboSubDistrict([]);
    FetchData("OPTIONS", `/${mod}/subdistrict`, app.token, {
      lang: app.lang,
      district_id: district_id,
    }).then((result) => {
      if (result.status === "ok") {
        setCboSubDistrict(result.subdistrict);
      } else {
        Func.exitApp();
      }
    });
  };

  const open = () => {
    setLoading(true);
    setConfirm(false);
    setTab(0);

    FetchData("GET", `/${mod}/${id}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === "ok") {
        district(result.data.province_id, result.data.district_id);
        subDistrict(result.data.district_id);
        setAttr({
          ...result.data,
          user_pass: "",
          user_pass_again: "",
          tel: Func.maskTel(result.data.tel),
        });

        setLoading(false);
      }
    });
  };

  const addConfirm = () => {
    if (!Func.verifyLength(attr.code, 3)) return;
    if (!Func.verifyLength(attr.name, 1)) return;
    if (!Func.verifyLength(attr.branch_id, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    setLoading(true);
    setModalAdd(false);

    FetchData("PUT", `/${mod}`, app.token, {
      code: attr.code,
      name: attr.name,
      surname: attr.surname,
      idcard: attr.idcard,
      tel: Func.formatTel(attr.tel),
      branch_id: attr.branch_id,
      address: attr.address,
      email: attr.email,
      province_id: attr.province_id,
      subdistrict_id: attr.subdistrict_id,
      district_id: attr.district_id,
      zipcode: attr.zipcode,
      enable: attr.enable,
    }).then((result) => {
      setLoading(false);

      if (result.status === "ok") {
        view(find);
        showNotify(t(`alert.addcomplete`), "success");
      } else {
        setModalAdd(true);
        showNotify(t(`alert.saveerror`), "error");
      }
    });
  };

  const editConfirm = () => {
    if (!Func.verifyLength(attr.code, 3)) return;
    if (!Func.verifyLength(attr.name, 1)) return;
    if (!Func.verifyLength(attr.branch_id, 1)) return;

    setConfirm(true);
  };

  const edit = () => {
    setLoading(true);

    FetchData("PATCH", `/${mod}/${attr.id}`, app.token, {
      code: attr.code,
      name: attr.name,
      surname: attr.surname,
      idcard: attr.idcard,
      role_id: attr.role_id,
      tel: Func.formatTel(attr.tel),
      branch_id: attr.branch_id,
      address: attr.address,
      email: attr.email,
      province_id: attr.province_id,
      subdistrict_id: attr.subdistrict_id,
      district_id: attr.district_id,
      zipcode: attr.zipcode,
      enable: attr.enable,
    }).then((result) => {
      setLoading(false);

      if (result.status === "ok") {
        open();

        showNotify(t(`alert.editcomplete`), "success");
      } else {
        showNotify(t(`alert.saveerror`), "error");
      }
    });
  };

  const registerConfirm = () => {
    if (!Func.verifyLength(attr.user_name, 5)) return;
    if (!Func.verifyLength(attr.user_pass, 5)) return;
    if (attr.user_pass !== attr.user_pass_again) return;

    setConfirmRegister(true);
  };

  const register = () => {
    setLoading(true);
    setConfirmRegister(false);

    FetchData("OPTIONS", `/${mod}/register`, app.token, {
      id: id,
      username: attr.user_name,
      password: attr.user_pass,
    }).then((result) => {
      setLoading(false);

      if (result.status === "ok") {
        setAttr({
          ...attr,
          user_pass: "",
          user_pass_again: "",
        });

        showNotify(t(`alert.editcomplete`), "success");
      } else {
        showNotify(t(`alert.saveerror`), "error");
      }
    });
  };

  const del = () => {
    setLoading(true);
    setModalDel(false);
    FetchData("DELETE", `/${mod}/${attr.id}`, app.token, {}).then((result) => {
      setLoading(false);

      if (result.status === "ok") {
        view(find);
        showNotify(t(`alert.deletecomplete`), "success");
      } else {
        showNotify(t(`alert.deleteerror`), "error");
      }
    });
  };

  const upload = (filedata) => {
    Swal.fire({
      title: t(`alert.confirm_edit_title`),
      icon: "warning",
      showDenyButton: true,
      confirmButtonColor: "#3085d6",
      confirmButtonText: t(`element.save`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: "#dc3545",
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        FetchData("OPTIONS", `/${mod}/upload`, app.token, {
          id: id,
          filedata: filedata,
        }).then((result) => {
          setLoading(false);

          if (result.status === "ok") {
            setAttr({
              ...attr,
              image: result.url,
            });

            showNotify(t(`alert.editcomplete`), "success");
          } else {
            showNotify(t(`alert.saveerror`), "error");
          }
        });
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  };

  const renderShow = (
    <Menu
      anchorEl={show}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={Boolean(show)}
      onClose={closeShow}
      keepMounted
    >
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 10 })}>
        {t(`element.show_record`, { num: 10 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 20 })}>
        {t(`element.show_record`, { num: 20 })}
      </MenuItem>
      <MenuItem onClick={() => view({ ...find, page: 1, perPage: 100 })}>
        {t(`element.show_record`, { num: 100 })}
      </MenuItem>
    </Menu>
  );

  const handleSort = (e, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);

    view({ ...find, order_by: property, order_sort: isAsc ? "desc" : "asc" });
  };

  const init = () => {
    FetchData("GET", `/${mod}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === "ok") {
        setAttr(initAttr);
        setCboProvince(result.province);
        setCboRole(result.role);
        setCboBranch(result.branch);

        if (id === undefined) {
          view(find);
        } else {
          open();
        }
      } else {
        Func.exitApp();
      }
    });
  };

  const enableDisplay = (inp) => {
    if (inp === "Y") return <Icon color="info">verified</Icon>;
    return <Icon color="error">not_interested</Icon>;
  };

  const imageDisplay = (item) => {
    return <Avatar alt={item.name} src={item.image} variant="rounded" />;
  };

  const btnOpen = (item) => {
    return (
      <NavLink to={`/${mod}/${item.id}`}>
        <MDButton
          variant="text"
          color="info"
          size="small"
          sx={{ fontSize: "1rem", whiteSpace: "nowrap" }}
        >
          {item.code}
        </MDButton>
      </NavLink>
    );
  };

  const renderList = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={9} md={10} lg={11}>
            <Card sx={{ p: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={3}>
                  <MDBox
                    noValidate
                    component="form"
                    role="form"
                    onSubmit={(e) => {
                      e.preventDefault();
                      view({ ...find, period: "ALL", page: 1 });
                    }}
                  >
                    <MDInput
                      name="searchform"
                      fullWidth
                      value={find.search}
                      type="search"
                      onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">{t("element.search")} :</InputAdornment>
                        ),
                        autoComplete: "off",
                      }}
                    />
                  </MDBox>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12} sm={3} md={2} lg={1}>
            <MDButton
              variant="contained"
              color="dark"
              size="large"
              fullWidth
              sx={{ pt: 1.6, pb: 1.6 }}
              onClick={() => {
                setCboDistrict([]);
                setCboSubDistrict([]);
                setAttr(initAttr);
                setConfirm(false);
                setModalAdd(true);
              }}
            >
              <Icon>post_add</Icon>
            </MDButton>
          </Grid>
          <Grid item xs={12}>
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHeader
                  order={order}
                  orderBy={orderBy}
                  onRequestSort={handleSort}
                  data={initHeader}
                />
                <TableBody>
                  {record.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell align="center">{imageDisplay(row)}</TableCell>
                      <TableCell align="left">{row.id}</TableCell>
                      <TableCell align="left">{btnOpen(row)}</TableCell>
                      <TableCell align="left">{row.name}</TableCell>
                      <TableCell align="left">{row.surname}</TableCell>
                      <TableCell align="left">{row.role_name}</TableCell>
                      <TableCell align="left">{row.branch_name}</TableCell>
                      <TableCell align="center">{row.user_name}</TableCell>
                      <TableCell align="center">{enableDisplay(row.enable)}</TableCell>
                      <TableCell align="center">{Func.dateTimeDisplay(row.created_at)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <MDBox display="flex" justifyContent="space-between" alignItems="flex-start">
                <MDButton variant={show ? "contained" : "outlined"} color="dark" onClick={openShow}>
                  {t(`element.show_record`, { num: find.perPage })}&nbsp;
                  <Icon>keyboard_arrow_down</Icon>
                </MDButton>
                {renderShow}
                <Pagination
                  count={pageTotal}
                  variant="outlined"
                  color="secondary"
                  showFirstButton
                  showLastButton
                  page={pageNo}
                  onChange={(e, p) => view({ ...find, page: p })}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderImage = () => {
    return (
      <Paper variant="outlined" sx={{ padding: 2, marginBottom: 2 }}>
        <MDTypography variant="h5" mb={3}>
          Avatar
        </MDTypography>
        <MDBox>
          {attr.image === "" ? null : (
            <MDBox component="img" src={attr.image} alt={attr.name} width="100%" height="100%" />
          )}
          <MDBox mr={1} display="flex" justifyContent="center">
            <UserUpload uploadData={upload} />
          </MDBox>
        </MDBox>
      </Paper>
    );
  };

  const renderAuthen = () => {
    return (
      <Paper variant="outlined" sx={{ padding: 2, marginBottom: 2 }}>
        <MDTypography variant="h5" mb={3}>
          Authentication
        </MDTypography>
        <MDBox>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <MDInput
                label="Username"
                onChange={(e) => setAttr({ ...attr, user_name: e.target.value })}
                value={attr.user_name}
                variant="standard"
                inputProps={{
                  autoComplete: "off",
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label="รหัสผ่าน"
                onChange={(e) => setAttr({ ...attr, user_pass: e.target.value })}
                value={attr.user_pass}
                variant="standard"
                type="password"
                inputProps={{
                  autoComplete: "off",
                }}
                fullWidth
              />
            </Grid>
            <Grid item xs={12}>
              <MDInput
                label="รหัสผ่าน อีกครั้ง"
                onChange={(e) => setAttr({ ...attr, user_pass_again: e.target.value })}
                value={attr.user_pass_again}
                variant="standard"
                type="password"
                inputProps={{
                  autoComplete: "off",
                }}
                fullWidth
              />
            </Grid>
          </Grid>
        </MDBox>

        {confirmRegister ? (
          <Grid container mt={3}>
            <Grid item xs={6}>
              <MDButton variant="outlined" color="error" onClick={() => setConfirmRegister(false)}>
                <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
              </MDButton>
            </Grid>
            <Grid item xs={6} display="flex" justifyContent="flex-end">
              <MDButton variant="gradient" color="success" onClick={register}>
                <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
              </MDButton>
            </Grid>
          </Grid>
        ) : (
          <Grid container mt={3}>
            <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
              <MDButton variant="outlined" color="success" onClick={registerConfirm}>
                <Icon>save</Icon>&nbsp;{t(`element.save`)}
              </MDButton>
            </Grid>
          </Grid>
        )}
      </Paper>
    );
  };

  const renderInfo = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <MDInput
            label="ชื่อ *"
            onChange={(e) => setAttr({ ...attr, name: e.target.value })}
            value={attr.name}
            variant="standard"
            inputProps={{
              autoComplete: "off",
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDInput
            label="นามสกุล"
            onChange={(e) => setAttr({ ...attr, surname: e.target.value })}
            value={attr.surname}
            variant="standard"
            inputProps={{
              autoComplete: "off",
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <MDSelect
            label="สาขา *"
            labelDefault={t(`element.please_select`)}
            data={cboBranch}
            value={attr.branch_id}
            onChange={(e) => setAttr({ ...attr, branch_id: e.target.value })}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <MDSelect
            label="สิทธิ์การใช้"
            labelDefault={t(`element.please_select`)}
            data={cboRole}
            value={attr.role_id}
            onChange={(e) => setAttr({ ...attr, role_id: e.target.value })}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDInput
            label="รหัส *"
            onChange={(e) => setAttr({ ...attr, code: e.target.value })}
            value={attr.code}
            variant="standard"
            inputProps={{
              maxLength: 3,
              autoComplete: "off",
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDInput
            label={`${t(`attr.idcard`)}`}
            onChange={(e) => setAttr({ ...attr, idcard: Func.maskIdCard(e.target.value) })}
            value={attr.idcard}
            variant="standard"
            fullWidth
            type="search"
            inputProps={{
              autoComplete: "off",
              maxLength: 17,
              placeholder: "0-0000-00000-00-0",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDInput
            label={`${t(`attr.tel`)}`}
            onChange={(e) => setAttr({ ...attr, tel: Func.maskTel(e.target.value) })}
            value={attr.tel}
            variant="standard"
            fullWidth
            type="search"
            inputProps={{
              autoComplete: "off",
              maxLength: 14,
              placeholder: "(000) 000 0000",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDInput
            label={`${t(`attr.email`)}`}
            onChange={(e) => setAttr({ ...attr, email: e.target.value })}
            value={attr.email}
            type="email"
            variant="standard"
            inputProps={{
              autoComplete: "off",
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <MDInput
            label={`${t(`attr.address`)}`}
            onChange={(e) => setAttr({ ...attr, address: e.target.value })}
            value={attr.address}
            variant="standard"
            multiline
            inputProps={{
              autoComplete: "off",
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDSelect
            label="จังหวัด"
            labelDefault={t(`element.please_select`)}
            data={cboProvince}
            value={attr.province_id}
            onChange={(e) => {
              setAttr({ ...attr, province_id: e.target.value, zipcode: "" });
              district(e.target.value);
            }}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDSelect
            label="อำเภอ / เขต"
            labelDefault={t(`element.please_select`)}
            data={cboDistrict}
            value={attr.district_id}
            onChange={(e) => {
              setAttr({ ...attr, district_id: e.target.value, zipcode: "" });
              subDistrict(e.target.value);
            }}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDSelect
            label="ตำบล / แขวง"
            labelDefault={t(`element.please_select`)}
            data={cboSubDistrict}
            value={attr.subdistrict_id}
            onChange={(e) => {
              cboSubDistrict.forEach((item, i) => {
                if (item.id === e.target.value) {
                  setAttr({ ...attr, subdistrict_id: e.target.value, zipcode: item.zip_code });
                }
              });
            }}
            inputProps={{
              autoComplete: "off",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <MDInput
            label="รหัสไปรษณีย์"
            onChange={(e) => setAttr({ ...attr, zipcode: e.target.value })}
            value={attr.zipcode}
            type="number"
            variant="standard"
            inputProps={{
              autoComplete: "off",
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12}>
          <MDCheckbox
            label="Enable"
            checked={attr.enable === "Y"}
            onChange={(e) => setAttr({ ...attr, enable: e.target.checked ? "Y" : "N" })}
          />
        </Grid>
      </Grid>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog open={modalAdd} maxWidth="md" keepMounted aria-describedby="dialog-add" fullWidth>
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label="close"
            onClick={() => setModalAdd(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant="text" color="error" onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <MDButton variant="outlined" color="success" onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant="text" color="info" onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderEdit = () => {
    return (
      <Dialog open={modalEdit} maxWidth="xs" keepMounted aria-describedby="dialog-edit" fullWidth>
        <DialogTitle>
          {t(`element.edit`)} #{attr.id}
          <IconButton
            aria-label="close"
            onClick={() => setModalEdit(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>{renderInfo()}</MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant="text" color="error" onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <MDButton variant="outlined" color="success" onClick={edit}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant="text" color="success" onClick={editConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderDelete = () => {
    return (
      <Dialog
        open={modalDel}
        onClose={() => setModalDel(false)}
        maxWidth="sm"
        keepMounted
        aria-describedby="dialog-delete"
      >
        <DialogTitle>
          {t(`element.delete`)} #{attr.id}
          <IconButton
            aria-label="close"
            onClick={() => setModalDel(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText p={5}>{t(`alert.confirm_delete_title`)}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant="text" color="error" onClick={() => setModalDel(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                <MDButton variant="gradient" color="error" onClick={del}>
                  <Icon>delete</Icon>&nbsp;{t(`element.deleteconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant="text" color="error" onClick={() => setConfirm(true)}>
              <Icon>delete</Icon>&nbsp;{t(`element.delete`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderInfoEdit = () => {
    return (
      <Paper variant="outlined" sx={{ padding: 2, marginBottom: 2 }}>
        <MDTypography variant="h5" mb={3}>
          {attr.name} {attr.surname}
        </MDTypography>
        {renderInfo()}

        {confirm ? (
          <Grid container mt={3}>
            <Grid item xs={6}>
              <MDButton variant="outlined" color="error" onClick={() => setConfirm(false)}>
                <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
              </MDButton>
            </Grid>
            <Grid item xs={6} display="flex" justifyContent="flex-end">
              <MDButton variant="gradient" color="success" onClick={edit}>
                <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
              </MDButton>
            </Grid>
          </Grid>
        ) : (
          <Grid container mt={3}>
            <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
              <MDButton variant="outlined" color="success" onClick={editConfirm}>
                <Icon>save</Icon>&nbsp;{t(`element.save`)}
              </MDButton>
            </Grid>
          </Grid>
        )}
      </Paper>
    );
  };

  const renderOpen = () => {
    return (
      <MDBox mb={7}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card sx={{ p: 2 }}>
              <Grid container>
                <Grid item xs={12}>
                  <NavLink to={`/${mod}`}>
                    <MDButton variant="contained" color="dark">
                      <Icon>arrow_back</Icon>&nbsp;{t(`element.back`)}
                    </MDButton>
                  </NavLink>
                </Grid>
              </Grid>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Card sx={{ p: 2 }}>
              <MDBox sx={{ width: "100%" }}>
                <MDBox>
                  <Tabs value={tab} onChange={(e, v) => setTab(v)} aria-label="tabs-addedit">
                    <Tab label={t(`element.info`)} />
                    <Tab label={t(`attr.image`)} />
                  </Tabs>
                </MDBox>
                <TabPanel value={tab} index={0}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={5} lg={5}>
                      {renderInfoEdit()}
                    </Grid>
                    <Grid item xs={12} sm={6} md={5} lg={5}>
                      {renderAuthen()}
                    </Grid>
                  </Grid>
                </TabPanel>
                <TabPanel value={tab} index={1}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={5} lg={3}>
                      {renderImage()}
                    </Grid>
                  </Grid>
                </TabPanel>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderPage = () => {
    if (id === undefined) return renderList();
    return renderOpen();
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <DashboardLayout>
      <Navbar route={[t(`menu.user`), t(`menu.user`)]} />
      {renderPage()}
      {renderAdd()}
      {renderEdit()}
      {renderDelete()}
      <Footer />
      {renderLoading()}
      {notify}
    </DashboardLayout>
  );
}

export default User;
